<div class="login-container">
  <div class="branding">
    <img src="/favicon.ico" alt="Kitty On Demand Logo" class="branding-logo" />
  </div>
  <mat-card>
    <mat-card-title>Login</mat-card-title>
      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" required>
            <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
              Email is required
            </mat-error>
            <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" required>
            <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
              Password is required
            </mat-error>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid || loading" class="login-button">
            <ng-container *ngIf="!loading; else loadingTpl">Login</ng-container>
            <ng-template #loadingTpl>
              <mat-spinner diameter="24" color="accent"></mat-spinner>
            </ng-template>
          </button>
        </form>
      </mat-card-content>
      <div class="login-link">
        <a href="/register" class="register-link">Don't have an account? Register</a>
      </div>
    </mat-card>
  </div>